module.exports = __webpack_public_path__ + "img/1562501683.b2db4271.jpg";